import CSS from './CloseButton.module.css';
import { ArrowIcon } from '@/assets/images';

type CloseButtonProps = { onClick?: () => void };

export const CloseButton = ({ onClick }: CloseButtonProps) => (
  <button onClick={onClick} className={CSS.closeButton} role="button">
    <ArrowIcon />
  </button>
);
